import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import { selectCartRemainingTime } from '../selectors';

const EmptyCart = () => {
    const remainingTime = useSelector(selectCartRemainingTime);
    return (
        <>
            <Row>
                <Col lg={{ span: 6, offset: 3 }} md={12}>
                    <div className="mt-5 mb-5 text-center text-secondary">
                        <div className="cart_empty_image mb-3"></div>
                        <h4 className="mb-3"><FormattedMessage id="cart_empty"/></h4>
                        {remainingTime === 0 && (<p><FormattedMessage id="cart_expired"/></p>)}
                        <a href="/" className={'btn btn-outline-secondary'}>
                            <FormattedMessage id="go_to_homepage"/>
                        </a>
                    </div>
                </Col>
            </Row>
        </>
    );
};
export default EmptyCart;
